import {useQuery} from 'react-query'
import {HotelEditModalForm} from './HotelEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_dashboard/helpers'
import {useListView} from '../core/ListViewProvider'
import { getOneById } from '../../../../services/common_requests'
import { initialHotel } from '../core/_models'

const HotelEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: hotel,
    error,
  } = useQuery(
    `${QUERIES.HOTELS_LIST}-hotel-${itemIdForUpdate}`,
    () => {
      return getOneById(itemIdForUpdate,"/hotels")
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <HotelEditModalForm isHotelLoading={isLoading} hotel={{...initialHotel, _id: undefined}} />
  }

  if (!isLoading && !error && hotel) {
    return <HotelEditModalForm isHotelLoading={isLoading} hotel={hotel} />
  }

  return null
}

export {HotelEditModalFormWrapper}
